import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { ConfigService } from './config.service';
import { UnitsOfService } from '../models/units-of-service.model';


@Injectable()
export class UnitsOfServiceService {
    readonly apiServer: string;

    constructor(private _configService: ConfigService, private _http: HttpClient) { 
        this.apiServer = this._configService.appSettings.webApiServer  + "api/UnitsOfService/";
    }

    async GetUnitsOfServiceByCategory(category: string): Promise<UnitsOfService> {
        const params = new HttpParams()
            .set('Category', category);

        return await this._http.get<UnitsOfService>(`${this.apiServer}GetUnitsOfServiceByCategory`, { params: params}).toPromise<UnitsOfService>();
    }

    async GetUnitsOfServiceById(id: number) : Promise<UnitsOfService> {
        const params = new HttpParams()
            .set('Id', id.toString());

        return await this._http.get<UnitsOfService>(`${this.apiServer}GetUnitsOfServiceById`, { params: params }).toPromise<UnitsOfService>();
    }

    async GetUnitsOfServices(mostRecent: boolean, offset: number, totalItems: number, searchText: string, orderBy: string, direction: string): Promise<UnitsOfService[]> {
        const params = new HttpParams()
            .set('mostRecent', mostRecent.toString())
            .set('offset', offset.toString())
            .set('totalItems', totalItems.toString())
            .set('searchText', searchText)
            .set('orderBy', orderBy)
            .set('direction', direction);

        return await this._http.get<UnitsOfService[]>(`${this.apiServer}GetUnitsOfServices`, { params: params }).toPromise<UnitsOfService[]>();
    }

    async RemoveUnitsOfService(id: number): Promise<boolean> {
        const params = new HttpParams()
            .set('Id', id.toString());

        return await this._http.delete<boolean>(`${this.apiServer}RemoveUnitsOfService`, { params: params }).toPromise<boolean>();
    }

    async UnitsOfServiceCategoryInUse(id: number): Promise<boolean> {
        const params = new HttpParams()
            .set('Id', id.toString());

        return await this._http.get<boolean>(`${this.apiServer}UnitsOfServiceCategoryInUse`, { params: params }).toPromise<boolean>();
    }

    async setUnitsOfService(UnitOfService: UnitsOfService): Promise<number> {            
        return await this._http.post<number>(`${this.apiServer}SetUnitsOfService`, JSON.stringify(UnitOfService)).toPromise<number>();
    }
}